import React, { useState } from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import { FaServer } from "react-icons/fa";
import "../styles/LocationMap.css";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const serverLocations = [
    { city: "Huntington", country: "USA", coordinates: [-81.6326, 38.3498], flag: "🇺🇸" },
    { city: "San Juan", country: "Puerto Rico", coordinates: [-66.1057, 18.4663], flag: "🇵🇷" },
    { city: "Zug", country: "Switzerland", coordinates: [8.5172, 47.1664], flag: "🇨🇭" },
    { city: "Valletta", country: "Malta", coordinates: [14.5146, 35.8989], flag: "🇲🇹" },
    { city: "Gibraltar", country: "Gibraltar", coordinates: [-5.3526, 36.1408], flag: "🇬🇮" },
    { city: "Minsk", country: "Belarus", coordinates: [27.5615, 53.9045], flag: "🇧🇾" },
    { city: "Moscow", country: "Russia", coordinates: [37.6173, 55.7558], flag: "🇷🇺" },
    { city: "Sofia", country: "Bulgaria", coordinates: [23.3219, 42.6977], flag: "🇧🇬" },
    { city: "Dubai", country: "UAE", coordinates: [55.2708, 25.2048], flag: "🇦🇪" },
    { city: "Manama", country: "Bahrain", coordinates: [50.5860, 26.2285], flag: "🇧🇭" },
    { city: "Singapore", country: "Singapore", coordinates: [103.8198, 1.3521], flag: "🇸🇬" },
    { city: "Hong Kong", country: "China", coordinates: [114.1095, 22.3964], flag: "🇭🇰" },
    { city: "Almaty", country: "Kazakhstan", coordinates: [76.9120, 43.2220], flag: "🇰🇿" },
    { city: "Taipei", country: "Taiwan", coordinates: [121.5654, 25.0330], flag: "🇹🇼" },
    { city: "Seoul", country: "South Korea", coordinates: [126.9780, 37.5665], flag: "🇰🇷" },
    { city: "St. Peter Port", country: "Guernsey", coordinates: [-2.5353, 49.4556], flag: "🇬🇬" },
    { city: "Tbilisi", country: "Georgia", coordinates: [44.8271, 41.7151], flag: "🇬🇪" },
    { city: "Yerevan", country: "Armenia", coordinates: [44.5136, 40.1811], flag: "🇦🇲" },
    { city: "Bishkek", country: "Kyrgyzstan", coordinates: [74.5827, 42.8746], flag: "🇰🇬" },
    { city: "Tallinn", country: "Estonia", coordinates: [24.7536, 59.4370], flag: "🇪🇪" },
    { city: "Reykjavik", country: "Iceland", coordinates: [-21.9426, 64.1466], flag: "🇮🇸" }
];

const LocationMap = () => {
    const [hoveredLocation, setHoveredLocation] = useState(null);

    return (
        <>
            <div className="server-coverage-section">
                <h2>
                    Our Global Server Infrastructure
                </h2>
                <p className="hero-description">
                    We operate high-performance data centers with dedicated validation servers across 22 strategic locations worldwide,
                    ensuring low-latency access and maximum uptime for all investors.
                </p>
            </div>

            <div className="map-container">
                <ComposableMap
                    projection="geoMercator"
                    projectionConfig={{
                        scale: 140,
                        center: [10, 40],
                        rotate: [0, 0, 0]
                    }}
                    height={400}
                    width={800}
                    style={{
                        width: '100%',
                        height: 'auto'
                    }}
                >
                    <Geographies geography={geoUrl}>
                        {({ geographies }) =>
                            geographies.map((geo) => (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    className="geography"
                                />
                            ))
                        }
                    </Geographies>

                    {serverLocations.map((location, index) => (
                        <Marker key={index} coordinates={location.coordinates}>
                            <circle
                                r={hoveredLocation === location ? 8 : 6}
                                className={`location-dot ${hoveredLocation === location ? 'hovered' : ''}`}
                                onMouseEnter={() => setHoveredLocation(location)}
                                onMouseLeave={() => setHoveredLocation(null)}
                            />
                        </Marker>
                    ))}
                </ComposableMap>

                {hoveredLocation && (
                    <div
                        className="location-tooltip"
                        style={{
                            left: `${(hoveredLocation.coordinates[0] + 180) / 3.6}%`,
                            top: `calc(${(90 - hoveredLocation.coordinates[1]) / 1.8}% - 10px)`,
                        }}
                    >
                        <div className="tooltip-icon">
                            <FaServer />
                        </div>
                        <div className="tooltip-city-country">
                            {hoveredLocation.city}, {hoveredLocation.country} {hoveredLocation.flag}
                        </div>
                        <div className="tooltip-stem" />
                    </div>
                )}
            </div>
        </>
    );
};

export default LocationMap;